import { createTheme, ThemeProvider } from "@mui/material/styles";

import RTL from "./RTL";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    white: true;
    light: true;
  }
  interface ButtonPropsColorOverrides {
    black: true;
  }
}
declare module "@mui/material/IconButton" {
  interface IconButtonPropsColorOverrides {
    black: true;
  }
}
declare module "@mui/material/styles" {
  interface Palette {
    black: Palette["primary"];
    tertiary: Palette["primary"];
  }

  interface PaletteOptions {
    black?: PaletteOptions["primary"];
    tertiary?: PaletteOptions["primary"];
  }
}

const MAIN_COLOR = "#4754CA";

const theme = createTheme({
  direction: "rtl",

  spacing: 8,

  typography: {
    fontFamily: "Dana, sans-serif",
  },

  palette: {
    mode: "light",
    primary: {
      main: MAIN_COLOR,
      contrastText: "#fff",
    },
    secondary: {
      main: "#21296B",
      contrastText: "#fff",
    },
    tertiary: {
      main: "red",
      contrastText: "#fff",
    },
    error: {
      main: "#FF0000",
      contrastText: "#fff",
    },
    black: {
      main: "#333",
      contrastText: "#fff",
    },
  },

  shape: {
    borderRadius: 7,
  },

  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        sizeLarge: { height: 56 },
        sizeSmall: { height: 36, minWidth: "auto", width: 36 },
        root: {
          minWidth: "56px",
        },
      },
      variants: [
        {
          props: { variant: "white" },
          style: {
            backgroundColor: "#fff",
            boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
            fontSize: "16px",
            color: "#000",

            "&:hover": {
              backgroundColor: "#f2f2f2",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
            },
          },
        },
        {
          props: { variant: "light" },
          style: {
            backgroundColor: "#F1F2FF",
            color: MAIN_COLOR,

            "&:hover": { backgroundColor: "#dde0ff" },
          },
        },
      ],
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        className: "fa-number",
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        className: "fa-number",
      },
    },
  },
});

export default function MUITheme({ children }: any) {
  return (
    <RTL>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </RTL>
  );
}
